import { render, staticRenderFns } from "./DwdcblrBrowse.vue?vue&type=template&id=2a321c54"
import script from "./DwdcblrBrowse.vue?vue&type=script&lang=js"
export * from "./DwdcblrBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports